import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../utils/api.js';
import Card from '../components/ui/Card.jsx';
import Button from '../components/ui/Button.jsx';
import Input from '../components/ui/Input.jsx';
import { formatIST } from '../utils/formatters.js';

export default function AuditLogPage() {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  const { data, isLoading } = useQuery({
    queryKey: ['audit', page, search],
    queryFn: () => api.get('/audit', { params: { page, limit: 50, action: search } }).then(r => r.data.data),
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Audit Log</h1>
          <p className="text-sm text-gray-500 mt-0.5">All system actions with full traceability</p>
        </div>
      </div>

      <Card>
        <div className="p-4 border-b">
          <Input placeholder="Filter by action…" value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} className="max-w-xs" />
        </div>
        {isLoading ? <div className="p-8 text-center text-gray-400">Loading…</div> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 border-b">
                <tr>{['Timestamp (IST)','User','Action','Entity','Entity ID','Changes'].map(h => (
                  <th key={h} className="text-left px-4 py-3 font-medium text-gray-600 text-xs uppercase tracking-wide">{h}</th>
                ))}</tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {(data?.items || []).map(log => (
                  <tr key={log.id} className="hover:bg-gray-50">
                    <td className="px-4 py-2 text-xs text-gray-400 whitespace-nowrap">{formatIST(log.timestamp)}</td>
                    <td className="px-4 py-2 text-gray-700">{log.user?.name || 'System'}</td>
                    <td className="px-4 py-2">
                      <span className="badge badge-checked">{log.action}</span>
                    </td>
                    <td className="px-4 py-2 text-gray-600">{log.entityType}</td>
                    <td className="px-4 py-2 font-mono text-xs text-gray-500">{log.entityId?.slice(0,12)}…</td>
                    <td className="px-4 py-2 text-xs text-gray-400 max-w-xs truncate">
                      {log.changes ? JSON.stringify(log.changes).slice(0, 80) : '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {data && data.total > data.limit && (
          <div className="px-4 py-3 border-t flex items-center justify-between text-sm text-gray-500">
            <span>Page {data.page} · {data.total} total entries</span>
            <div className="flex gap-2">
              <Button variant="secondary" size="sm" disabled={data.page <= 1} onClick={() => setPage(p => p - 1)}>Prev</Button>
              <Button variant="secondary" size="sm" disabled={data.page * data.limit >= data.total} onClick={() => setPage(p => p + 1)}>Next</Button>
            </div>
          </div>
        )}
      </Card>
    </div>
  );
}
